/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Read({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} clipPath="url(#Read_svg__a)"><path d="M1 6.244v7.666a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6.244M15 6.244l-4.525-4.202c-1.367-1.27-3.583-1.27-4.95 0L1 6.244M15 12.744l-3.5-3.25M1 12.744l3.5-3.25" /><path d="m1 6.244 4.525 4.201c1.367 1.27 3.583 1.27 4.95 0L15 6.244" /></g><defs><clipPath id="Read_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;